import { useEffect, useState } from 'react';

import {
  listEventStageRoutes,
  StageRouteGeometry,
} from '../services/fleet';

export function useEventStageRoutes(eventId: number | null): {
  routes: StageRouteGeometry[];
  loading: boolean;
} {
  const [routes, setRoutes] = useState<StageRouteGeometry[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (eventId == null) {
      setRoutes([]);
      return;
    }
    let cancelled = false;
    setLoading(true);
    void listEventStageRoutes(eventId)
      .then((rows) => {
        if (!cancelled) setRoutes(rows);
      })
      .catch((error) => {
        if (!cancelled) {
          setRoutes([]);
          console.warn('[useEventStageRoutes] fetch failed', error);
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [eventId]);

  return { routes, loading };
}

export default useEventStageRoutes;
